<stx-generic-wide-page>
  <stx-report-header>{{ 'reports.surgical_follow_up_visits' | translate }}</stx-report-header>
  <stx-report-filters [reportConfig]="reportConfig" (applyFilters)="applyFilters($event)"></stx-report-filters>
  @if (reportService.initialized$ | async) {
  <stx-surgical-follow-up-visits-report-table></stx-surgical-follow-up-visits-report-table>
  }
</stx-generic-wide-page>
